// production hardware data
import shipping_options from './shipping.prod'

export default [
    {
        label: 'Bat Attachment',
        description: 'for Quest 2',
        stripe_product_id: 'prod_ISMrY4Bm3TjC4J',
        stripe_price_id: 'price_1LZzfCIDrm6Z6HgYdByLCxJE',
        price: 2500,
        wc_id: 1416,
        category: 'bat_attachment',
        shipping_options,
        max_quantity: 20,
    },
    {
        label: 'Bat Attachment',
        description: 'for Quest 3',
        stripe_product_id: 'prod_OpgnJnrzuWhyuU',
        stripe_price_id: 'price_1O21QLIDrm6Z6HgYlBlHyLyv',
        price: 2500,
        wc_id: 1417,
        category: 'bat_attachment',
        shipping_options,
        max_quantity: 20,
    },
    {
        label: 'Bat Attachment',
        description: 'for Quest 2',
        stripe_product_id: 'prod_ISMrY4Bm3TjC4J',
        stripe_price_id: 'price_1LZzfCIDrm6Z6HgYdByLCxJE',
        price: 0,
        coupon: 'YQHgfCAv',
        wc_id: 1519,
        category: 'bat_attachment',
        shipping_options,
        max_quantity: 20,
    },
    {
        label: 'Bat Attachment',
        description: 'for Quest 3',
        stripe_product_id: 'prod_OpgnJnrzuWhyuU',
        stripe_price_id: 'price_1O21QLIDrm6Z6HgYlBlHyLyv',
        price: 0,
        coupon: 'YQHgfCAv',
        wc_id: 1518,
        category: 'bat_attachment',
        shipping_options,
        max_quantity: 20,
    },
    {
        label: 'Short Bat',
        description: 'Shortened bat that holds a controller. Works with Quest 2 and Quest 3 headsets.',
        stripe_product_id: 'prod_P3DtPBbAvPCUg2',
        stripe_price_id: 'price_1OF7RyIDrm6Z6HgYIUpV0taa',
        price: 0,
        wc_id: 113698,
        category: 'short_bat',
        shipping_options: shipping_options.filter(option => option.id === 'standard'),
        max_quantity: 1,
    },
    {
        label: 'Short Bat',
        description: 'Shortened bat that holds a controller. Works with Quest 2 and Quest 3 headsets.',
        stripe_product_id: 'prod_P3DtPBbAvPCUg2',
        stripe_price_id: 'price_1OIgy0IDrm6Z6HgYzRl0406T',
        price: 9900,
        wc_id: 113699,
        category: 'short_bat',
        shipping_options: shipping_options.filter(option => option.id === 'standard'),
        max_quantity: 1,
    },
    {
        label: 'Meta Quest 2 Headset',
        description: 'Virtual reality headset',
        stripe_product_id: 'prod_P8RvJihPzDXuRt',
        stripe_price_id: 'price_1P6YbnIDrm6Z6HgYHrfT51tl',
        price: 42900,
        wc_id: 117908,
        category: 'headset',
        shipping_options: shipping_options.filter(option => option.id === 'standard'),
        max_quantity: 1,
        bundle_only: true,
    },
] as Hardware[]
